import {
    Box,
    Button,
    Divider,
    IconButton,
    Link,
    Stack,
    ToggleButtonGroup,
    Typography,
} from "@mui/material";
import WidgetHeader from "../../widgets/WidgetHeader.tsx";
import { appSession } from "../../TR3AD.ts";
import { Link as RouterLink, Navigate, useNavigate, useParams } from "react-router";
import { appStyles } from "../../AppStyles.ts";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useEffect, useState } from "react";
import {
    StyledInputBase,
    StyledSearch,
    StyledSearchIconWrapper,
    StyledFilterToggleButton,
} from "../AppStyledComponents";
import IntelProfileCard from "../../cards/IntelProfileCard.tsx";
import { SessionIntelProfile } from "../../sdo/SessionIntelProfile.ts";

export type ProfileViewState = {
    autoConnect: boolean | undefined;
    networkUID: string | undefined;
    redirectURL: string | undefined;
};

type FilterToggle =
    | "all"
    | "asset"
    | "attribute"
    | "category"
    | "contract"
    | "entity"
    | "event"
    | "factor"
    | "identifier"
    | "measurement"
    | "place"
    | "relationship"
    | "selector"
    | "temporal";

type IntelProfileSample = SessionIntelProfile & { type: Exclude<FilterToggle, "all"> };

function UXNetworkHome() {
    const { networkUID } = useParams();
    const navigate = useNavigate();

    const [filterToggle, setFilterToggle] = useState<FilterToggle>("all");
    const [profiles, setProfiles] = useState<IntelProfileSample[]>([]);
    const [filterText, setFilterText] = useState("");

    // Hand-entered sample data (12 entries)
    const SAMPLE_INTEL_PROFILES: IntelProfileSample[] = [
        { key: "ENTITY.ACCOUNT", name: "Accounts", icon: "account", type: "entity", total: 5 },
        { key: "EVENT.APPOINTMENT", name: "Appointments", icon: "event", type: "event", total: 60 },
        { key: "MEASUREMENT", name: "Binance Coin", icon: "unit", type: "measurement", total: 43 },
        { key: "ATTRIBUTE.COLOR", name: "Colors", icon: "attribute", type: "attribute", total: 9 },
        { key: "RELATIONSHIP.PERSONAL.CITIZEN", name: "Citizens", icon: "person", type: "relationship" , total: 15 },
        { key: "RELATIONSHIP.PERSONAL.FAMILY", name: "Family", icon: "person", type: "relationship", total: 3 },
        { key: "PLACE.CITY", name: "Cities", icon: "place", type: "place", total: 49 },
        { key: "EVENT.CONFERENCE", name: "Conferences", icon: "event", type: "event", total: 932 },
        { key: "ENTITY.VEHICLE.AUTOMOBILE", name: "Automobiles", icon: "vehicle", type: "entity", total: 2 },
        { key: "ENTITY.COMPUTER", name: "Computers", icon: "device", type: "entity", total: 23},
        { key: "MEASUREMENT.COORDINATES", name: "Coordinates", icon: "unit", type: "measurement", total: 11 },
        { key: "CONTRACT.BUSINESS.BUSINESS_PARTNER", name: "Business Partners", icon: "credential", type: "contract", total: 2 },
    ];

    useEffect(() => {
        reload();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function reload() {
        console.log("UXNetworkHome::reload (sample data)");
        setProfiles(SAMPLE_INTEL_PROFILES);
    }

    const filteredProfiles = profiles.filter((p) => {
        // toggle filter
        const matchesToggle = filterToggle === "all" || p.type === filterToggle;

        // name filter
        const q = filterText.trim().toLowerCase();
        const matchesName = q.length === 0 || p.name.toLowerCase().includes(q);

        return matchesToggle && matchesName;
    });

    // --- return starts below (per your request) ---

    return (
        <Stack direction="column" width="100%" minHeight="100vh">
            {appSession.activeSession() === false ? (
                <Navigate to="/" />
            ) : (
                <Stack direction="column" spacing={1} width="99%" >
                    <WidgetHeader
                        title="Home"
                        breadcrumbs={[
                        {
                            display: "Networks",
                            linkTo: `/networks/`,
                            activeView: false
                        },
                        {
                            display: String(networkUID),
                            linkTo: "",
                            activeView: true
                        }]}
                    />
                    <Stack direction="row" spacing={1} alignItems="center" width="100%" >
                        <Stack direction="row" spacing={1} alignItems="center"
                            sx={appStyles.bannerBox}
                            height="100%">
                            <IconButton title="Network Image Settings" component={RouterLink} to={`/networks/${networkUID}/settings`}>
                                <img src="/images/default_network_image.png" width={128} />
                            </IconButton>
                        </Stack>
                        <Stack
                            sx={appStyles.bannerBox}
                            direction="column"
                            padding={1}
                            alignItems="center"
                            height="100%"
                            width="100%">
                            <Typography sx={{ ...appStyles.mainIntelTitle, textAlign: "center", width: "100%" }} flexWrap="wrap">Network Hometown</Typography>
                            <Stack direction="row" spacing={1} padding={1} alignItems="center">
                                <Stack direction="column"
                                       sx={appStyles.networkStatNavigation}
                                       component={RouterLink} to={`/networks/${networkUID}/settings`}
                                       alignItems="center"
                                       minHeight={110}
                                       minWidth={140}>
                                    <Typography paddingBottom={1} sx={{ ...appStyles.cardTitleLabel}}> Network</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailText}}> YIXB8CWQ</Typography>
                                    <Typography paddingBottom={1} sx={{ ...appStyles.cardDetailLabel}}> UID</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailText}}> Active</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailLabel}}> Status</Typography>
                                </Stack>
                                <Stack direction="column"
                                       sx={appStyles.networkStatNavigation}
                                       component={RouterLink} to={`/networks/${networkUID}/settings`}
                                       alignItems="center"
                                       minHeight={110}
                                       minWidth={140}>
                                    <Typography paddingBottom={1} sx={{ ...appStyles.cardTitleLabel}}> Access</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailText}}> PRIVATE</Typography>
                                    <Typography paddingBottom={1} sx={{ ...appStyles.cardDetailLabel}}> Access Type</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailText}}> 1</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailLabel}}> Authorized Users</Typography>
                                </Stack>
                                <Stack direction="column"
                                       sx={appStyles.networkStatNavigation}
                                       component={RouterLink} to={`/networks/${networkUID}/settings`}
                                       alignItems="center"
                                       minHeight={110}
                                       minWidth={140}>
                                    <Typography paddingBottom={1} sx={{ ...appStyles.cardTitleLabel}}> Credits</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailText}}> 0</Typography>
                                    <Typography paddingBottom={1} sx={{ ...appStyles.cardDetailLabel}}> Used</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailText}}> 100,000</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailLabel}}> Remaining</Typography>
                                </Stack>
                                <Stack direction="column"
                                       sx={appStyles.networkStatNavigation}
                                       component={RouterLink} to={`/networks/${networkUID}/settings`}
                                       alignItems="center"
                                       minHeight={110}
                                       minWidth={140}>
                                    <Typography paddingBottom={1} sx={{ ...appStyles.cardTitleLabel}}> Requests</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailText}}> 0</Typography>
                                    <Typography paddingBottom={1} sx={{ ...appStyles.cardDetailLabel}}> Pending</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailText}}> 1,487</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailLabel}}> Total</Typography>
                                </Stack>
                                <Stack direction="column"
                                       sx={appStyles.networkStatNavigation}
                                       component={RouterLink} to={`/networks/${networkUID}/settings`}
                                       alignItems="center"
                                       minHeight={110}
                                       minWidth={140}>
                                    <Typography paddingBottom={1} sx={{ ...appStyles.cardTitleLabel}}> Processing</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailText}}> 2,973</Typography>
                                    <Typography paddingBottom={1} sx={{ ...appStyles.cardDetailLabel}}> Total</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailText}}> 00:00:11:58</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailLabel}}> Time</Typography>
                                </Stack>
                                <Stack direction="column"
                                       sx={appStyles.networkStatNavigation}
                                       component={RouterLink} to={`/networks/${networkUID}/settings`}
                                       alignItems="center"
                                       minHeight={110}
                                       minWidth={140}>
                                    <Typography paddingBottom={1} sx={{ ...appStyles.cardTitleLabel}}> Level of Effort</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailText}}> 1,486</Typography>
                                    <Typography paddingBottom={1} sx={{ ...appStyles.cardDetailLabel}}> Tasks</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailText}}> 00:01:11:46</Typography>
                                    <Typography sx={{ ...appStyles.cardDetailLabel}}> Time</Typography>
                                </Stack>
                                <Divider orientation="vertical" flexItem sx={{mx: 4, width: '1px',}}/>
                                <Stack direction="column" padding={1} alignItems="center">
                                    <Stack direction="row"
                                           sx={appStyles.networkStatNavigation}
                                           component={RouterLink} to={`/networks/${networkUID}/settings`}
                                           padding={1}
                                           alignItems="center"
                                           height={50}
                                           width={50}>
                                        <img src="/images/navigation_settings.svg" height={32} />
                                    </Stack>
                                    <Typography sx={appStyles.primaryLabel} flexWrap="wrap"> Settings</Typography>
                                </Stack>
                            </Stack>
                        </Stack>
                    </Stack>
                    <Stack
                        sx={appStyles.defaultPanelContainer}
                        spacing={2}
                        width="100%"
                        height="100%"
                        alignItems="center">
                        <Stack direction="row" spacing={1} padding={1} alignItems="center">
                            {/*Collect*/}
                            <Stack direction="column" padding={0} width="100%">
                                <Stack direction="row">
                                    <Stack sx={appStyles.actionPinkBorderTopLeft}>
                                    </Stack>
                                    <Stack direction="row" sx={appStyles.actionPinkBorderTopRight}>
                                        <img src="/images/action_collect.svg" height={30} />
                                        <Typography paddingLeft={1} sx={appStyles.actionPanelTitle}>COLLECT</Typography>
                                    </Stack>
                                </Stack>
                                <Stack direction="row">
                                    <Stack width={25} height={45}>
                                    </Stack>
                                    <Stack direction="row" sx={appStyles.actionPinkBorderBottomRight}>
                                        <Stack direction="column" padding={1} alignItems="center">
                                            <Stack direction="row"
                                                   sx={appStyles.networkStatNavigation}
                                                   component={RouterLink} to={`/networks/${networkUID}/settings`}
                                                   padding={1}
                                                   alignItems="center"
                                                   height={48}
                                                   width={48}>
                                                <img src="/images/connections.svg" height={28} />
                                            </Stack>
                                            <Typography sx={appStyles.primaryLabel} flexWrap="wrap"> Connections</Typography>
                                        </Stack>
                                        <Stack direction="column" padding={1} alignItems="center">
                                            <Stack direction="row"
                                                   sx={appStyles.networkStatNavigation}
                                                   component={RouterLink} to={`/networks/${networkUID}/importers`}
                                                   padding={1}
                                                   alignItems="center"
                                                   height={46}
                                                   width={46}>
                                                <img src="/images/importers.svg" height={28} />
                                            </Stack>
                                            <Typography sx={appStyles.primaryLabel} flexWrap="wrap"> Importers</Typography>

                                        </Stack>
                                        <Stack direction="column" padding={1} alignItems="center" >
                                            <Stack direction="row"
                                                   sx={appStyles.networkStatNavigation}
                                                   component={RouterLink} to={`/networks/${networkUID}/research`}
                                                   padding={1}
                                                   alignItems="center"
                                                   height={46}
                                                   width={46}>
                                                <img src="/images/researchers.svg" height={28} />
                                            </Stack>
                                            <Typography sx={appStyles.primaryLabel} flexWrap="wrap"> Researchers</Typography>
                                        </Stack>
                                    </Stack>
                                </Stack>
                            </Stack>
                            {/*Analyze*/}
                            <Stack direction="column" padding={0} width="100%">
                                <Stack direction="row">
                                    <Stack sx={appStyles.actionGreenBorderTopLeft}>
                                    </Stack>
                                    <Stack direction="row" sx={appStyles.actionGreenBorderTopRight}>
                                        <img src="/images/action_analyze.svg" height={30} />
                                        <Typography paddingLeft={1} sx={appStyles.actionPanelTitle}>ANALYZE</Typography>
                                    </Stack>
                                </Stack>
                                <Stack direction="row">
                                    <Stack width={25} height={45}>
                                    </Stack>
                                    <Stack direction="row" sx={appStyles.actionGreenBorderBottomRight}>
                                        <Stack direction="column" padding={1} alignItems="center">
                                            <Stack direction="row"
                                                   sx={appStyles.networkStatNavigation}
                                                   component={RouterLink} to={`/networks/${networkUID}/graphs`}
                                                   padding={1}
                                                   alignItems="center"
                                                   height={48}
                                                   width={48}>
                                                <img src="/images/graph.svg" height={28} />
                                            </Stack>
                                            <Typography sx={appStyles.primaryLabel} flexWrap="wrap"> Graph</Typography>
                                        </Stack>
                                        <Stack direction="column" padding={1} alignItems="center">
                                            <Stack direction="row"
                                                   sx={appStyles.networkStatNavigation}
                                                   component={RouterLink} to={`/networks/${networkUID}/locations`}
                                                   padding={1}
                                                   alignItems="center"
                                                   height={46}
                                                   width={46}>
                                                <img src="/images/locations.svg" height={28} />
                                            </Stack>
                                            <Typography sx={appStyles.primaryLabel} flexWrap="wrap"> Locations</Typography>
                                        </Stack>
                                        <Stack direction="column" padding={1} alignItems="center" >
                                            <Stack direction="row"
                                                   sx={appStyles.networkStatNavigation}
                                                   component={RouterLink} to={`/networks/${networkUID}/search`}
                                                   padding={1}
                                                   alignItems="center"
                                                   height={46}
                                                   width={46}>
                                                <img src="/images/search.svg" height={28} />
                                            </Stack>
                                            <Typography sx={appStyles.primaryLabel} flexWrap="wrap"> Search</Typography>
                                        </Stack>
                                        <Stack direction="column" padding={1} alignItems="center">
                                            <Stack direction="row"
                                                   sx={appStyles.networkStatNavigation}
                                                   component={RouterLink} to={`/networks/${networkUID}/tags`}
                                                   padding={1}
                                                   alignItems="center"
                                                   height={46}
                                                   width={46}>
                                                <img src="/images/tags.svg" height={28} />
                                            </Stack>
                                            <Typography sx={appStyles.primaryLabel} flexWrap="wrap"> Tags</Typography>
                                        </Stack>
                                        <Stack direction="column" padding={1} alignItems="center" >
                                            <Stack direction="row"
                                                   sx={appStyles.networkStatNavigation}
                                                   component={RouterLink} to={`/networks/${networkUID}/timeline`}
                                                   padding={1}
                                                   alignItems="center"
                                                   height={46}
                                                   width={46}>
                                                <img src="/images/timeline.svg" height={28} />
                                            </Stack>
                                            <Typography sx={appStyles.primaryLabel} flexWrap="wrap"> Timeline</Typography>
                                        </Stack>
                                    </Stack>

                                </Stack>

                            </Stack>
                            {/*Evaluate*/}
                            <Stack direction="column" padding={0} width="100%">
                                <Stack direction="row">
                                    <Stack sx={appStyles.actionOrangeBorderTopLeft}>
                                    </Stack>
                                    <Stack direction="row" sx={appStyles.actionOrangeBorderTopRight}>
                                        <img src="/images/action_evaluate.svg" height={30} />
                                        <Typography paddingLeft={1} sx={appStyles.actionPanelTitle}>EVALUATE</Typography>
                                    </Stack>
                                </Stack>
                                <Stack direction="row">
                                    <Stack width={25} height={45}>
                                    </Stack>
                                    <Stack direction="row" sx={appStyles.actionOrangeBorderBottomRight}>
                                        <Stack direction="column" padding={1} alignItems="center">
                                            <Stack direction="row"
                                                   sx={appStyles.networkStatNavigation}
                                                   component={RouterLink} to={`/networks/${networkUID}/ai_analyst`}
                                                   padding={1}
                                                   alignItems="center"
                                                   height={46}
                                                   width={46}>
                                                <img src="/images/ai_analyst.svg" height={28} />
                                            </Stack>
                                            <Typography noWrap sx={appStyles.primaryLabel}> AI Analyst</Typography>
                                        </Stack>
                                        <Stack direction="column" padding={1} alignItems="center" >
                                            <Stack direction="row"
                                                   sx={appStyles.networkStatNavigation}
                                                   component={RouterLink} to={`/networks/${networkUID}/discussions`}
                                                   padding={1}
                                                   alignItems="center"
                                                   height={46}
                                                   width={46}>
                                                <img src="/images/discussions.svg" height={28} />
                                            </Stack>
                                            <Typography sx={appStyles.primaryLabel} flexWrap="wrap"> Discussions
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                </Stack>
                            </Stack>
                            {/*Visualize*/}
                            <Stack direction="column" padding={0} width="100%">
                                <Stack direction="row">
                                    <Stack sx={appStyles.actionBlueBorderTopLeft}>
                                    </Stack>
                                    <Stack direction="row" sx={appStyles.actionBlueBorderTopRight}>
                                        <img src="/images/action_visualize.svg" height={30} />
                                        <Typography paddingLeft={1} sx={appStyles.actionPanelTitle}>VISUALIZE</Typography>
                                    </Stack>
                                </Stack>
                                <Stack direction="row">
                                    <Stack width={25} height={45}>
                                    </Stack>
                                    <Stack direction="row" sx={appStyles.actionBlueBorderBottomRight}>
                                        <Stack direction="column" padding={1} alignItems="center">
                                            <Stack direction="row"
                                                   sx={appStyles.networkStatNavigation}
                                                   component={RouterLink} to={`/networks/${networkUID}/dashboards`}
                                                   padding={1}
                                                   alignItems="center"
                                                   height={46}
                                                   width={46}>
                                                <img src="/images/dashboards.svg" height={28} />
                                            </Stack>
                                            <Typography noWrap sx={appStyles.primaryLabel} > Dashboards
                                            </Typography>
                                        </Stack>
                                        <Stack direction="column" padding={1} alignItems="center" >
                                            <Stack direction="row"
                                                   sx={appStyles.networkStatNavigation}
                                                   component={RouterLink} to={`/networks/${networkUID}/reports`}
                                                   padding={1}
                                                   alignItems="center"
                                                   height={46}
                                                   width={46}>
                                                <img src="/images/reports.svg" height={28} />
                                            </Stack>
                                            <Typography sx={appStyles.primaryLabel} flexWrap="wrap"> Reports
                                            </Typography>
                                        </Stack>
                                        <Stack direction="column" padding={1} alignItems="center">
                                            <Stack direction="row"
                                                   sx={appStyles.networkStatNavigation}
                                                   component={RouterLink} to={`/networks/${networkUID}/storyboards`}
                                                   padding={1}
                                                   alignItems="center"
                                                   height={46}
                                                   width={46}>
                                                <img src="/images/storyboards.svg" height={28} />
                                            </Stack>
                                            <Typography noWrap sx={appStyles.primaryLabel} > Storyboards
                                            </Typography>
                                        </Stack>
                                        <Stack direction="column" padding={1} alignItems="center" >
                                            <Stack direction="row"
                                                   sx={appStyles.networkStatNavigation}
                                                   component={RouterLink} to={`/networks/${networkUID}/publishers`}
                                                   padding={1}
                                                   alignItems="center"
                                                   height={46}
                                                   width={46}>
                                                <img src="/images/publishers.svg" height={28} />
                                            </Stack>
                                            <Typography sx={appStyles.primaryLabel} flexWrap="wrap"> Publishers
                                            </Typography>
                                        </Stack>
                                    </Stack>

                                </Stack>

                            </Stack>
                        </Stack>

                    </Stack>
                    <Stack
                        sx={appStyles.defaultPanelContainer}
                        spacing={1}
                        width="100%"
                        height="100%"
                        alignItems="center">

                        {/*Show navigation button bar Resources*/}
                        <Typography sx={{ ...appStyles.secondaryPanelTitleWhite, width: "100%", paddingTop: 1 }} flexWrap="wrap">Resources</Typography>
                        <Stack direction="row" spacing={1} padding={1} alignItems="center">
                            <Stack direction="row"
                                   sx={appStyles.networkStatNavigation}
                                   component={RouterLink} to={`/networks/${networkUID}/resources/files`}
                                   alignItems="center"
                                   justifyContent="center"
                                   minHeight={65}
                                   minWidth={175}
                                   width="100%">
                                <img src="/images/resource_files.svg" width={45} />
                                <Stack direction="column" alignItems="start" justifyContent="center" paddingLeft={1} height="100%">
                                    <Typography sx={{ ...appStyles.cardLargeDetailText}}> 5</Typography>
                                    <Typography sx={{ ...appStyles.cardTitleLabel}}> Files</Typography>
                                </Stack>
                            </Stack>
                            <Divider orientation="vertical" flexItem sx={{mx: 4, width: '1px',}}/>
                            <Stack direction="row"
                                   sx={appStyles.networkStatNavigation}
                                   component={RouterLink} to={`/networks/${networkUID}/resources/pages`}
                                   alignItems="center"
                                   justifyContent="center"
                                   minHeight={65}
                                   minWidth={175}
                                   width="100%">
                                <img src="/images/resource_pages.svg" width={45} />
                                <Stack direction="column" alignItems="start" justifyContent="center" paddingLeft={1} height="100%">
                                    <Typography sx={{ ...appStyles.cardLargeDetailText}}> 5</Typography>
                                    <Typography sx={{ ...appStyles.cardTitleLabel}}> Pages</Typography>
                                </Stack>
                            </Stack>
                            <Divider orientation="vertical" flexItem sx={{mx: 4, width: '1px',}}/>
                            <Stack direction="row"
                                   sx={appStyles.networkStatNavigation}
                                   component={RouterLink} to={`/networks/${networkUID}/resources/records`}
                                   alignItems="center"
                                   justifyContent="center"
                                   minHeight={65}
                                   minWidth={175}
                                   width="100%">
                                <img src="/images/resource_records.svg" width={45} />
                                <Stack direction="column" alignItems="start" justifyContent="center" paddingLeft={1} height="100%">
                                    <Typography sx={{ ...appStyles.cardLargeDetailText}}> 0</Typography>
                                    <Typography sx={{ ...appStyles.cardTitleLabel}}> Records</Typography>
                                </Stack>
                            </Stack>
                            <Divider orientation="vertical" flexItem sx={{mx: 4, width: '1px',}}/>
                            <Stack direction="row"
                                   sx={appStyles.networkStatNavigation}
                                   component={RouterLink} to={`/networks/${networkUID}/resources/enrichments`}
                                   alignItems="center"
                                   justifyContent="center"
                                   minHeight={65}
                                   minWidth={175}
                                   width="100%">
                                <img src="/images/resource_enrichments.svg" width={45} />
                                <Stack direction="column" alignItems="start" justifyContent="center" paddingLeft={1} height="100%">
                                    <Typography sx={{ ...appStyles.cardLargeDetailText}}> 0</Typography>
                                    <Typography sx={{ ...appStyles.cardTitleLabel}}> Enrichments</Typography>
                                </Stack>
                            </Stack>
                            <Divider orientation="vertical" flexItem sx={{mx: 4, width: '1px',}}/>
                            <Stack direction="row"
                                   sx={appStyles.networkStatNavigation}
                                   component={RouterLink} to={`/networks/${networkUID}/workspaces`}
                                   alignItems="center"
                                   justifyContent="center"
                                   minHeight={65}
                                   minWidth={175}
                                   width="100%">
                                <img src="/images/resource_workspaces.svg" width={45} />
                                <Stack direction="column" alignItems="start" justifyContent="center" paddingLeft={1} height="100%">
                                    <Typography sx={{ ...appStyles.cardLargeDetailText}}> 0</Typography>
                                    <Typography sx={{ ...appStyles.cardTitleLabel}}> Workspaces</Typography>
                                </Stack>
                            </Stack>
                        </Stack>
                    </Stack>
                    <Stack
                        sx={appStyles.defaultPanelContainer}
                        spacing={2}
                        direction="column"
                        width="100%"
                        height="100%"
                        alignItems="center">

                        <Stack spacing={2} direction="row" width="100%" height="100%" alignItems="center">
                            <Stack direction="row" padding={1} justifyItems="center" alignItems="start" width={150}></Stack>
                            <Typography sx={{ ...appStyles.secondaryPanelTitleWhite, width: "100%", paddingTop: 1 }} flexWrap="wrap">Intelligence Profiles</Typography>
                            <Stack direction="row" padding={1} justifyItems="center" alignItems="end" width={150}>
                                <Button
                                    sx={appStyles.buttonStyle}
                                    startIcon={<AddCircleOutlineIcon />}
                                    onClick={() => navigate(`/networks/${networkUID}/intel/create`)}
                                >CREATE</Button>
                            </Stack>
                        </Stack>
                        <Stack spacing={2} direction="column" width="100%" height="100%" alignItems="center">
                            <Stack direction="row" alignItems="center" justifyItems="center">
                                <StyledSearch>
                                    <StyledSearchIconWrapper>
                                        <img src="/images/search_white.svg" width={16} />
                                    </StyledSearchIconWrapper>
                                    <StyledInputBase
                                        placeholder="Filter"
                                        value={filterText}
                                        onChange={(e) => setFilterText(e.target.value)}
                                        inputProps={{ "aria-label": "search" }}
                                    />
                                </StyledSearch>
                                <Typography sx={{ ...appStyles.showCountText, paddingTop: 1 }}>
                                    Showing {filteredProfiles.length} of {profiles.length}
                                </Typography>
                            </Stack>

                        </Stack>
                        <Stack spacing={0} padding={1} direction="column" width="100%" height="100%" alignItems="center">
                            <ToggleButtonGroup
                                value={filterToggle}
                                exclusive
                                aria-label="filter"
                                onChange={(_, newValue: FilterToggle | null) => {
                                    if (newValue) setFilterToggle(newValue);
                                }}
                                sx={appStyles.toggleButtonStyle}>
                                <StyledFilterToggleButton value="all" aria-label="all">All</StyledFilterToggleButton>
                                <StyledFilterToggleButton value="asset" aria-label="asset">Assets</StyledFilterToggleButton>
                                <StyledFilterToggleButton value="attribute" aria-label="attribute">Attributes</StyledFilterToggleButton>
                                <StyledFilterToggleButton value="category" aria-label="category">Categories</StyledFilterToggleButton>
                                <StyledFilterToggleButton value="contract" aria-label="contract">Contracts</StyledFilterToggleButton>
                                <StyledFilterToggleButton value="entity" aria-label="entity">Entities</StyledFilterToggleButton>
                                <StyledFilterToggleButton value="event" aria-label="event">Events</StyledFilterToggleButton>
                                <StyledFilterToggleButton value="factor" aria-label="factor">Factors</StyledFilterToggleButton>
                                <StyledFilterToggleButton value="identifier" aria-label="identifier">Identifiers</StyledFilterToggleButton>
                                <StyledFilterToggleButton value="measurement" aria-label="measurement">Measurements</StyledFilterToggleButton>
                                <StyledFilterToggleButton value="place" aria-label="place">Places</StyledFilterToggleButton>
                                <StyledFilterToggleButton value="relationship" aria-label="relationship">Relationships</StyledFilterToggleButton>
                                <StyledFilterToggleButton value="selector" aria-label="selector">Selectors</StyledFilterToggleButton>
                                <StyledFilterToggleButton value="temporal" aria-label="temporal">Temporals</StyledFilterToggleButton>
                            </ToggleButtonGroup>
                        </Stack>
                        <Stack direction="column" alignItems="center">
                            <Box sx={appStyles.defaultPanelCardsWrapper} width="98%" height="100%">
                                <Box sx={{ overflowY: "auto", flexGrow: 1, p: 1 }}>
                                    <Box
                                        sx={{
                                            display: "grid",
                                            gridTemplateColumns: "repeat(3, 330px)",
                                            gap: 2,
                                            justifyContent: "center",
                                            justifyItems: "center",
                                            width: "100%",
                                        }}
                                    >
                                        {profiles.length === 0 ? (
                                            <Typography variant="body2" color="text.secondary">
                                                Loading profile data...
                                            </Typography>
                                        ) : (
                                            filteredProfiles.map((nextProfile) => (
                                                <IntelProfileCard
                                                    key={`profile_${nextProfile.key}`}
                                                    entry={nextProfile}
                                                    networkUID={String(networkUID)}
                                                />
                                            ))
                                        )}
                                    </Box>
                                </Box>
                            </Box>
                        </Stack>


                    </Stack>
                    <Stack
                        sx={appStyles.defaultPanelContainer}
                        spacing={2}
                        width="100%"
                        height="100%"
                        alignItems="start"
                    >
                        <Link sx={appStyles.secondaryLabel} key="intel" component={RouterLink} to={`/networks/${networkUID}/intel/entity/person`}>Intel / Entity / Person</Link>
                        <Link sx={appStyles.secondaryLabel} key="intel_viewer" component={RouterLink} to={`/networks/${networkUID}/intel/entity/person/rob`}>Intel / Entity / Person / Rob</Link>

                        <Link sx={appStyles.secondaryLabel} key="resources" component={RouterLink} to={`/networks/${networkUID}/resources/file/pdf`}>Resources / File / PDF</Link>
                        <Link sx={appStyles.secondaryLabel} key="resource_viewer" component={RouterLink} to={`/networks/${networkUID}/resources/file/pdf/34993943`}>Resources / File / PDF / 34993943</Link>

                        <Link sx={appStyles.secondaryLabel} key="transactions" component={RouterLink} to={`/networks/${networkUID}/settings/transactions`}>Transactions</Link>
                        <Link sx={appStyles.secondaryLabel} key="explorers" component={RouterLink} to={`/networks/${networkUID}/explorers`}>Explorers</Link>

                    </Stack>
                </Stack>
            )}
        </Stack>
    );
}

export default UXNetworkHome;